import { useApi, Status, EmptyData } from "./useApi";
import { IAPanel } from "./IA";

export const HBars = ({ obj, max, testid }) => {
  const ks = Object.keys(obj || {}).sort((a, b) => obj[b] - obj[a]);
  const m = max || Math.max(1, ...ks.map((k) => obj[k]));
  if (!ks.length) return <p className="note">Sin datos.</p>;
  return (
    <div data-testid={testid}>
      {ks.map((k) => <div className="hb" key={k}><span>{k}</span><div className="pbar"><i style={{ width: `${(obj[k] / m) * 100}%` }}></i></div><b>{obj[k]}</b></div>)}
    </div>
  );
};

const PK = ["P", "E", "R", "M", "A", "GLOBAL", "N", "EST"];

const Heat = ({ rows }) => (
  <table className="tbl heat" data-testid="panel-perma-table">
    <thead><tr><th style={{ textAlign: "left" }}>Deporte</th><th>n</th>{PK.map((k) => <th key={k}>{k}</th>)}</tr></thead>
    <tbody>
      {rows.map((r) => (
        <tr key={r.deporte}><td style={{ textAlign: "left" }}>{r.deporte}</td><td>{r.n}</td>
          {PK.map((k) => {
            const v = r[k];
            const bad = v != null && (k === "N" ? v >= 6 : v < 6.5);
            return <td key={k} style={{ color: v == null ? undefined : bad ? "#FFD2D2" : "#9FE3B8" }}>{v == null ? "–" : v.toFixed(1)}</td>;
          })}
        </tr>
      ))}
    </tbody>
  </table>
);

const Resumen = () => {
  const { data } = useApi("/resumen");
  if (!data) return null;
  return (
    <p className="note" data-testid="panel-resumen">Base de atletas: <b data-testid="panel-atletas">{data.atletas}</b> atletas · <b data-testid="panel-menores">{data.menores}</b> menores de edad · <b data-testid="panel-consentimientos">{data.consentimientos}</b> consentimientos por confirmar · <b data-testid="panel-documentos">{data.documentos}</b> documentos</p>
  );
};

const Mes = ({ porMes }) => {
  const mx = Math.max(1, ...porMes.map((m) => m[1]));
  if (!porMes.length) return <p className="note">Sin datos.</p>;
  return (
    <div className="vbars" data-testid="panel-por-mes">
      {porMes.map(([m, n]) => <div key={m} title={`${m}: ${n}`}><b style={{ color: "#fff" }}>{n}</b><i style={{ height: `${(n / mx) * 100}%` }}></i>{m.slice(2)}</div>)}
    </div>
  );
};

const segPrefill = (p) => ({
  titulo: `Seguimiento · ${p.nombre}`, deporte: p.deporte, club: p.club, equipoId: p.equipoId, periodo: p.periodo,
  fecha: new Date().toISOString().slice(0, 10),
  campos: { atletaId: p.atletaId, estado: "Abierto", nota: `Atención prioritaria: global ${p.GLOBAL ?? "–"}, N ${p.N ?? "–"}, estabilidad ${p.EST ?? "–"} (señal de seguimiento, no diagnóstico).\n` },
});

const Prioridad = ({ list, onReg, onSeg }) => (
  <div className="panel">
    <h4 data-testid="panel-prioridad-title">Atención prioritaria ({list.length})</h4>
    <p className="note">Regla: N ≥ 6.5, estabilidad &lt; 5.5 o global &lt; 5.5. Es una señal de seguimiento, no un diagnóstico.</p>
    <div className="wrapx">
      <table className="tbl" data-testid="panel-prioridad-table">
        <thead><tr><th>Atleta</th><th>Equipo</th><th>Global</th><th>N</th><th>Estab.</th><th>Seguimiento</th></tr></thead>
        <tbody>{list.map((p) => (
          <tr key={p.id} className="clk" onClick={() => onReg(p.id)} data-testid={`prioridad-row-${p.id}`}><td>{p.nombre}</td><td>{p.equipo}</td><td>{p.GLOBAL ?? "–"}</td><td>{p.N ?? "–"}</td><td>{p.EST ?? "–"}</td>
            <td style={{ whiteSpace: "nowrap" }}>
              <button className="chip" style={{ background: "var(--sol)", color: "var(--ink)" }} onClick={(e) => { e.stopPropagation(); onSeg(segPrefill(p)); }} data-testid={`prioridad-seguimiento-btn-${p.id}`}>+ Seguimiento</button>
              {p.seguimientos > 0 && <> <span className="badge g" data-testid={`prioridad-seguimientos-${p.id}`}>{p.seguimientos} hecho{p.seguimientos > 1 ? "s" : ""}</span></>}
            </td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  </div>
);

const Antes = ({ list }) => (
  <div className="panel" data-testid="panel-actividades">
    <h4>Actividades: antes y después</h4>
    {list.length ? (
      <table className="tbl"><thead><tr><th>Actividad</th><th>Registros</th><th>Cambio promedio</th></tr></thead>
        <tbody>{list.map((a) => <tr key={a.actividad}><td>{a.actividad}</td><td>{a.n}</td><td>{a.cambio ?? "–"}</td></tr>)}</tbody></table>
    ) : <p className="note">Aún no hay participaciones. Cuando los deportistas practiquen las fichas de “Actividades” o completen el pasaporte, aparecerán aquí.</p>}
  </div>
);

export const PanelView = ({ F, onReg, onSeg }) => {
  const { data, error } = useApi("/panel", F);
  if (!data) return <Status data={data} error={error} />;
  const c = data.cards;
  return (
    <div data-testid="panel-view">
      <p className="note">Todo lo que ves se calcula en vivo desde los formularios (los documentos del Drive ya cargados como registros, más lo que se registre desde hoy).</p>
      <Resumen />
      <div className="stats4">
        <div className="stat"><b data-testid="card-evaluaciones">{c.evaluaciones}</b><span>evaluaciones PERMA</span></div>
        <div className="stat"><b data-testid="card-protocolos">{c.protocolos}</b><span>protocolos</span></div>
        <div className="stat"><b data-testid="card-sesiones">{c.sesiones}</b><span>sesiones de campo</span></div>
        <div className="stat"><b data-testid="card-participaciones">{c.participaciones}</b><span>participaciones en actividades</span></div>
        <div className="stat"><b data-testid="card-prioridad">{c.prioridad}</b><span>atención prioritaria</span></div>
      </div>
      {c.evaluaciones + c.protocolos + c.sesiones === 0 && <EmptyData />}
      <IAPanel F={F} />
      <div className="g2">
        <div className="panel"><h4>Sesiones de campo por mes</h4><Mes porMes={data.porMes} /></div>
        <div className="panel"><h4>Sesiones por deporte</h4><HBars obj={data.porDeporte} testid="panel-por-deporte" /></div>
      </div>
      <div className="g2">
        <div className="panel"><h4>Habilidades trabajadas</h4><p className="note">Según la habilidad, el tema y el objetivo de protocolos y diarios.</p><HBars obj={data.habilidades} testid="panel-habilidades" /></div>
        <div className="panel"><h4>Completitud de los formularios</h4><p className="note">% de campos llenos por plantilla. Lo que falta se completa editando cada registro.</p><HBars obj={data.completitud} max={100} testid="panel-completitud" /></div>
      </div>
      <div className="panel"><h4>Bienestar PERMA promedio por deporte</h4><div className="wrapx"><Heat rows={data.perma} /></div></div>
      <Prioridad list={data.prioridad} onReg={onReg} onSeg={onSeg} />
      <Antes list={data.actividades} />
    </div>
  );
};
